<template>
  <CBox :bg="['#F1F2F4', 'var(--colors-light-primary-light-gray)']" minHeight="100vh" width="100vw" position="sticky">
    <OmtLayoutContainer bg="#F1F2F4">
      <OmtRow
        :mt="['-24px', '-40px']"
        mb="16px"
        bg="white"
        px="16px"
        py="16px"
        :mx="['-16px', '-40px']"
        border-bottom-left-radius="8px"
        border-bottom-right-radius="8px"
      >
        <CFlex direction="column" grid-gap="16px">
          <OmtInput
            variant="filled"
            placeholder="Filtre por especialidade"
            icon-left="search"
            :icon-right="inputText.length > 0 ? 'times' : undefined"
            :iconLeftClick="onSearch"
            :iconRightClick="inputText.length > 0 ? clearSearch : undefined"
            v-model="inputText"
            v-on:keydown.enter.prevent="onSearch"
            :borderColor="searchInputBorderColor"
            :_focus="{ borderColor: searchInputBorderColor, boxShadow: 'initial' }"
            @focus="isSearchInputFocused = true"
            @blur="isSearchInputFocused = false"
          />
          <!-- <OmtRow v-if="homeLocation || enderecoSelecionado">
            <LocationCard
              :title="locationTitle"
              :subtitle="locationSubtitle"
              :isLocationDisabled="isCurrentLocationDisabled"
              @click="onLocationClick"
            />
          </OmtRow> -->
        </CFlex>
      </OmtRow>
      <OmtRow :mx="['-16px', '-40px']" px="16px">
        <CFlex direction="column" grid-gap="16px">
          <OmtRow>
            <OmtTypography as="h3-bold" max-w="235px"> Selecione a especialidade </OmtTypography>
          </OmtRow>
          <OmtRow
            bg="white"
            flex-direction="column"
            p="16px"
            border-radius="8px"
            v-if="filteredSpecialities.length > 0"
          >
            <CBox v-for="(spec, idx) in filteredSpecialities" :key="'spec-' + idx">
              <OmtTile @click="handleClick(spec)" cursor="pointer" :divider="false">
                <OmtTypography as="p1">
                  {{ capitalizeWords(spec.DescricaoEspecialidade) }}
                </OmtTypography>
              </OmtTile>
              <OmtDivider v-if="idx !== filteredSpecialities.length - 1" />
            </CBox>
          </OmtRow>
          <OmtRow v-if="showAffiliateIndication" @click="redirectToAffiliateIndication" mt="42px">
            <CBox bg="var(--colors-light-primary-light-gray)" py="14px" px="16px" border-radius="12px">
              <OmtTile :divider="false" icon="lightbulb">
                <OmtTypography as="h2-bold" max-w="235px">
                  Gostaria de uma indicação de um especialista?
                </OmtTypography>
              </OmtTile>
            </CBox>
          </OmtRow>
        </CFlex>
      </OmtRow>

      <ModalSearchAddress
        :is-open="showLocationModal"
        :home-location="homeLocation"
        @close="closeLocationModal"
        @select="handleAddressSelection"
      />

      <ModalSearchOtherAddress
        :is-open="showOtherAddressModal"
        @close="closeOtherAddressModal"
        @apply="handleOtherAddressSelection"
      />
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import LocationCard from "@/components/Organisms/AffiliateSearch/LocationCard";
import ModalSearchAddress from "@/components/Organisms/AffiliateSearch/ModalSearchAddress";
import ModalSearchOtherAddress from "@/components/Organisms/AffiliateSearch/ModalSearchOtherAddress";
import { mapActions, mapMutations, mapState } from "vuex";
import { shouldAutoSelectSpecialtyForTour } from "@/utils/buscaRedeTour";

export default {
  name: "SpecialitiesList",
  components: {
    LocationCard,
    ModalSearchAddress,
    ModalSearchOtherAddress
  },
  data() {
    return {
      prevRoute: "/redecredenciada-home",
      inputText: "",
      showLocationModal: false,
      showOtherAddressModal: false,
      isSearchInputFocused: false
    };
  },
  beforeRouteEnter(_, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },
  async mounted() {
    if (!this.group) {
      await this.$router.replace({ name: "affiliate" });
      return;
    }

    // Se não tiver permissão de localização, força a seleção para a primeira opção válida
    if (this.locationDisabled) {
      const hasCurrentAsSelected =
        this.enderecoSelecionado &&
        (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual");

      const hasCurrentAsHome =
        !this.enderecoSelecionado &&
        this.homeLocation &&
        (this.homeLocation.Tipo === "atual" || this.homeLocation.Tipo === "Atual");

      if (hasCurrentAsSelected || hasCurrentAsHome) {
        const addresses = this.$store.state.affiliate.addresses || [];
        const savedAddresses = addresses.filter(endereco => endereco.Tipo !== "atual");
        const fallbackAddress = savedAddresses.find(addr => addr.Tipo !== "outra-cidade") || savedAddresses[0];

        if (fallbackAddress) {
          this.SET_ENDERECO_SELECIONADO(fallbackAddress);
        }
      }
    }

    try {
      this.$root.$emit("change-title-label", this.capitalizeWords(this.group));
      this.$root.$emit("change-back-route", "/redecredenciada-home");
      await this.$root.$emit("show-loading");
      if (
        this.prevRoute === "/redecredenciada-home" ||
        this.prevRoute === "/redecredenciada" ||
        this.prevRoute === "/redecredenciada/" ||
        !this.specialities?.length
      ) {
        await this.fetchSpecialities(this.tipoAtendimento);
      }

      if (shouldAutoSelectSpecialtyForTour() && this.specialities?.length) {
        const preferred =
          this.specialities.find(spec =>
            String(spec.DescricaoEspecialidade || "")
              .toLowerCase()
              .includes("psicolog")
          ) || this.specialities[0];
        this.handleClick(preferred);
        return;
      }
    } catch (error) {
      this.$router.replace({ name: "affiliate" });
      this.$toast({
        description: error instanceof Error ? error.message : error,
        status: "error",
        duration: 10000,
        position: "top"
      });
    } finally {
      await this.$root.$emit("hide-loading");
    }
  },
  computed: {
    ...mapState("affiliate", [
      "specialities",
      "group",
      "tipoAtendimento",
      "allowAffiliateIndication",
      "homeLocation",
      "enderecoSelecionado",
      "locationDisabled"
    ]),
    filteredSpecialities() {
      if (!this.inputText) return this.specialities;

      return this.specialities.filter(speciality =>
        speciality.DescricaoEspecialidade.toLowerCase().includes(this.inputText.toLowerCase())
      );
    },
    showAffiliateIndication() {
      if (!this.allowAffiliateIndication) return false;
      return this.tipoAtendimento === "mediclin" || this.tipoAtendimento === "terapia";
    },
    searchInputBorderColor() {
      return this.isSearchInputFocused
        ? "var(--colors-light-primary-navy-blue)"
        : "var(--colors-light-secondary-divider)";
    },
    locationTitle() {
      if (this.enderecoSelecionado) {
        if (
          (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual") &&
          this.enderecoSelecionado.Titulo
        ) {
          return this.enderecoSelecionado.Titulo;
        }
        return this.enderecoSelecionado.Titulo || "Localização";
      }
      return this.homeLocation?.Titulo || "Localização";
    },
    locationSubtitle() {
      if (this.enderecoSelecionado) {
        if (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual") {
          return "Buscando pela sua localização atual";
        }
        return this.enderecoSelecionado.Descricao || this.formatLocationSubtitle(this.enderecoSelecionado);
      }
      if (!this.homeLocation) return "";
      if (this.homeLocation.Tipo === "Atual" || this.homeLocation.Tipo === "atual") {
        return "Buscando pela sua localização atual";
      }
      return this.homeLocation.Descricao || this.formatLocationSubtitle(this.homeLocation);
    },
    isCurrentLocationDisabled() {
      if (!this.locationDisabled) return false;

      const isEnderecoAtual =
        this.enderecoSelecionado &&
        (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual");

      const isHomeAtual =
        !this.enderecoSelecionado &&
        this.homeLocation &&
        (this.homeLocation.Tipo === "atual" || this.homeLocation.Tipo === "Atual");

      return !!(isEnderecoAtual || isHomeAtual);
    }
  },
  methods: {
    ...mapActions("affiliate", ["fetchSpecialities", "saveSearchHistory"]),
    ...mapMutations("affiliate", ["SET_SPECIALITY", "SET_ENDERECO_SELECIONADO"]),
    async onSearch() {
      if (!this.inputText || !this.inputText.trim()) return;
      await this.saveSearchHistory(this.inputText);
    },
    handleClick(spec) {
      this.SET_SPECIALITY({ cod: spec.CodigoEspecialidade, label: spec.DescricaoEspecialidade });

      this.$router.push({ name: "affiliate.docs", params: { fetchResults: true } });
    },
    clearSearch() {
      this.inputText = "";
    },
    redirectToAffiliateIndication() {
      this.$router.push({ path: "/indicacao-de-credenciados/criar-indicacao" });
    },
    capitalizeWords(inputString) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
    },
    formatLocationSubtitle(location) {
      if (location.Endereco) return location.Endereco;
      const cityState = [location.Cidade, location.Uf].filter(Boolean).join("/");
      return [cityState, location.Cep].filter(Boolean).join(" - ");
    },
    onLocationClick() {
      this.showLocationModal = true;
    },
    closeLocationModal() {
      this.showLocationModal = false;
    },
    openOtherAddressModal() {
      this.showOtherAddressModal = true;
    },
    closeOtherAddressModal() {
      this.showOtherAddressModal = false;
    },
    handleAddressSelection(payload) {
      if (payload?.type === "outra-cidade") {
        this.$root.$emit("show-loading");
        this.$store
          .dispatch("affiliate/fetchStatesNetwork")
          .then(() => {
            this.closeLocationModal();
            this.openOtherAddressModal();
          })
          .finally(() => {
            this.$root.$emit("hide-loading");
          });
        return;
      }

      this.SET_ENDERECO_SELECIONADO(payload?.data || null);
      this.closeLocationModal();
    },
    handleOtherAddressSelection(payload) {
      if (payload?.type === "outra-cidade-selecionada") {
        this.SET_ENDERECO_SELECIONADO({
          ...payload.data,
          Tipo: "outra-cidade-selecionada"
        });
      }
    }
  }
};
</script>
